export const TEACHER_ROLE = 'teacher';
export const STUDENT_ROLE = 'student';
export const UNKNOWN_ROLE = '';